import Vue from 'vue'
import './plugins/axios'
import './plugins/vue-touch'
import App from './App.vue'
import router from './router'
import store from './store/index'

Vue.config.productionTip = false

window.ppApp = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
